<template>
  <v-app id="yoyaku">
    <header-bar />
    <v-main width="100%" style="background-color: #f5f5f5">
      <go-to-top-button />
      <warn-message class="mt-5" :messages="errorMessages" />
      <success-message class="mt-5" :messages="successMessages" />
      <error-message-dialog :messages="errorMessages" />
      <progress-dialog :color="color" />
      <router-view />
    </v-main>
    <footer-bar />
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import HeaderBar from '@/components/yoyaku/HeaderBar.vue';
import GoToTopButton from '@/components/GoToTopButton.vue';
import WarnMessage from '@/components/WarnMessage.vue';
import SuccessMessage from '@/components/SuccessMessage.vue';
import ErrorMessageDialog from '@/components/ErrorMessageDialog.vue';
import ProgressDialog from '@/components/dialog/ProgressDialog.vue';
import FooterBar from '@/components/yoyaku/FooterBar.vue';
import { getSuccessMessageMap, getErrorMessageMap } from '@/libs/messages';
import { getColor } from '@/libs/llc/database/property';

@Component({
  components: {
    HeaderBar,
    GoToTopButton,
    WarnMessage,
    SuccessMessage,
    ErrorMessageDialog,
    ProgressDialog,
    FooterBar,
  },
})
export default class Yoyaku extends Vue {
  get property(): any {
    return Store.getters.yoyaku.property;
  }

  get color(): string {
    return getColor(this.property);
  }

  get successMessages() {
    return getSuccessMessageMap(this.property);
  }

  get errorMessages() {
    return getErrorMessageMap(this.property);
  }
}
</script>

<style lang="scss" scoped>
#yoyaku {
  /* Google fontsで導入したいfontsからfont-familyを取ってくる */
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 17px !important;
}
</style>
